import React from "react"
import DropdownInput from "../../../../../components/molecules/DropdownInput.molecule"
import DropdownCustomFilterSearch from "../../../../../components/molecules/DropdownCustomFilterSearch.molecule"
import {
  checkAllFields,
  fieldsDoesNotHaveErrors,
} from "../../../../../utils/validations.utils"
import InputPlaceholderChipTemplate from "../../../../../components/molecules/InputPlaceholderChipTemplate.molecule"

const ModuleChipDropdown = ({
  value,
  onChange,
  label = "Elige un módulo",
  name = "moduleTagName",
  options,
  optionValue = "moduleID",
  optionLabel = "moduleName",
  error,
  dropdownRef,
  onPressEnter,
  loading,
  formValidations,
  setFormValidations,
  handleFormSubmit,
  disabled,
  highlighted,
  ...props
}) => {
  if (!options) return
  const moduleName =
    value ?
      options.find((option) => option?.[optionValue] === value)?.[optionLabel]
    : ""

  return (
    <div className={`dropdown-module-filter-inplace`}>
      <DropdownInput
        resetFilterOnHide={true}
        ref={dropdownRef}
        name={name}
        filter
        className="modules-dropdown"
        placeholder={label}
        options={options}
        optionValue={optionValue}
        optionLabel={optionLabel}
        value={value}
        onChange={(e) => {
          onChange(e)
        }}
        itemTemplate={(option) => {
          return (
            <span className="overflow-hidden text-overflow-ellipsis whitespace-nowrap">
              {option.moduleName}
            </span>
          )
        }}
        scrollHeight="417px"
        emptyMessage="No hay modulos aquí... ¡este cliente es minimalista!"
        filterTemplate={(props) => (
          <DropdownCustomFilterSearch
            props={props}
            inputProps={{
              autoFocus: true,
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  checkAllFields(formValidations, setFormValidations)
                  if (fieldsDoesNotHaveErrors(formValidations)) {
                    handleFormSubmit()
                    return
                  }
                }

                if (e.key === "Enter" || e.key === "Tab") {
                  dropdownRef?.current?.hide()
                  if (e.key === "Tab") {
                    e.preventDefault()
                  }
                  onPressEnter(e)
                }
                props.filterInputKeyDown(e)
              },
            }}
          />
        )}
        panelClassName={`${loading ? "loading" : ""} dropdown-module-filter-panel max-w-23rem`}
      />

      <InputPlaceholderChipTemplate
        selected={moduleName}
        highlighted={highlighted}
        error={error}
        disabled={disabled}
        template={
          // eslint-disable-next-line
          <span className="p-chip-text text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem">
            {moduleName || label}{" "}
            {error ?
              <i
                className="pi pi-exclamation-triangle"
                data-pr-tooltip="Este es un campo requerido"
                data-pr-position="bottom"
              />
            : null}
          </span>
        }
        onClick={() => {
          dropdownRef.current?.show()
        }}
      />
    </div>
  )
}

export default ModuleChipDropdown
